<div class="page-header">
  <div>
    <h1>Approval Queue</h1>
    <p>Transfers awaiting a decision, plus recent history by state.</p>
  </div>
  <button mat-stroked-button (click)="refresh()" [disabled]="loading()">
    <mat-icon>refresh</mat-icon>
    Refresh
  </button>
</div>

<div class="queue-toolbar">
  <mat-form-field appearance="outline" class="state-field">
    <mat-label>State</mat-label>
    <mat-select [(ngModel)]="selectedState" (selectionChange)="refresh()">
      @for (state of states; track state) {
        <mat-option [value]="state">{{ state.replaceAll('_', ' ') }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="limit-field">
    <mat-label>Limit</mat-label>
    <input matInput type="number" [(ngModel)]="limit" min="1" max="200" (change)="refresh()" />
  </mat-form-field>
</div>

@if (errorMessage(); as message) {
  <p class="queue-error">{{ message }}</p>
}

@if (loading()) {
  <div class="queue-loading">
    <mat-spinner diameter="32" />
  </div>
} @else {
  <div class="card-surface queue-card">
    @if (items().length === 0) {
      <div class="queue-empty">
        <mat-icon>inbox</mat-icon>
        <p>No transactions in this state.</p>
      </div>
    } @else {
      <table mat-table [dataSource]="items()" class="queue-table">
        <ng-container matColumnDef="control_reference">
          <th mat-header-cell *matHeaderCellDef>Control Reference</th>
          <td mat-cell *matCellDef="let item" class="mono">{{ item.control_reference }}</td>
        </ng-container>

        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef class="col-amount">Amount</th>
          <td mat-cell *matCellDef="let item" class="col-amount mono">
            {{ item.amount | currency: 'NGN' : 'symbol-narrow' : '1.2-2' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="trigger_reason">
          <th mat-header-cell *matHeaderCellDef>Trigger Reason</th>
          <td mat-cell *matCellDef="let item">{{ item.trigger_reason.replaceAll('_', ' ') }}</td>
        </ng-container>

        <ng-container matColumnDef="state">
          <th mat-header-cell *matHeaderCellDef>State</th>
          <td mat-cell *matCellDef="let item"><app-status-badge [state]="item.state" /></td>
        </ng-container>

        <ng-container matColumnDef="created_at">
          <th mat-header-cell *matHeaderCellDef>Created</th>
          <td mat-cell *matCellDef="let item">{{ item.created_at | date: 'MMM d, y, h:mm a' }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columns"></tr>
        <tr
          mat-row
          *matRowDef="let item; columns: columns"
          class="queue-row"
          (click)="open(item)"
        ></tr>
      </table>
    }
  </div>
}
